// In Node, the main is generally called the index.js

export {default as func} from './src/funcWorld';


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0